import { render, staticRenderFns } from "./BookingChooseService.vue?vue&type=template&id=4831e103&scoped=true&lang=pug&"
import script from "./BookingChooseService.vue?vue&type=script&lang=ts&"
export * from "./BookingChooseService.vue?vue&type=script&lang=ts&"
import style0 from "./BookingChooseService.vue?vue&type=style&index=0&id=4831e103&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831e103",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDivider,VFlex,VIcon,VLayout,VProgressCircular,VSpacer})
